import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { MessageCategory, Guid, ServerResponseStatus, EventEmitter } from './../../../../common/index';
import { WebSocketProxyEvents } from './../utilitites/application.constants';
import { AppConfig } from './../utilitites/app-config';
export var WebSocketProxy = function () {
  function WebSocketProxy() {
    _classCallCheck(this, WebSocketProxy);

    _defineProperty(this, "_websocketClient", void 0);

    _defineProperty(this, "_isConnected", false);

    _defineProperty(this, "_eventEmitter", void 0);

    _defineProperty(this, "_currentUser_UserName", "");

    _defineProperty(this, "_deviceConnectionId", "");

    _defineProperty(this, "_loggerInstance", void 0);

    this._eventEmitter = new EventEmitter();
    this._loggerInstance = window['Logger'];
  }

  _createClass(WebSocketProxy, [{
    key: "getWebSocketInstance",
    value: function getWebSocketInstance() {
      var _this = this;

      var self = this;
      return new Promise(function (resolve, reject) {
        if (!_this._isConnected) {
          _this._loggerInstance.logEvent('Connecting with Signal-Server');

          self._websocketClient = new W3CWebSocket(AppConfig.SignalServerEndPoint);

          self._websocketClient.onopen = function () {
            self._websocketClient.onmessage = _this.OnMessage.bind(_this);
            self._websocketClient.onerror = _this.OnError.bind(_this);
            self._websocketClient.onclose = _this.OnClose.bind(_this);
            self._isConnected = true;
            resolve(self._websocketClient);
          };

          self._websocketClient.onerror = function (error) {
            console.error("An error occured while connecting to websocket server. Error Object: ");
            console.error(error);

            _this._loggerInstance.logException(error);

            reject(error);
          };
        } else {
          resolve(self._websocketClient);
        }
      });
    }
  }, {
    key: "Login",
    value: function Login(username, deviceConnectionId) {
      var self = this;
      this._currentUser_UserName = username;

      if (deviceConnectionId || deviceConnectionId.length > 0) {
        this._deviceConnectionId = deviceConnectionId;
      }

      var message = {
        messageFrom: this._currentUser_UserName,
        messageType: MessageCategory.TYPE_LOGIN,
        senderDeviceUniqueConnectionId: this._deviceConnectionId
      };
      return this.getWebSocketInstance().then(function (connection) {
        self._loggerInstance.logEvent('Sending Login Request to Signal Server');

        connection.send(JSON.stringify(message));
      });
    }
  }, {
    key: "LeaveRoomAndLogOut",
    value: function LeaveRoomAndLogOut(roomId, userId, deviceConnectionId) {
      var self = this;
      var leaveRoomMessage = {
        messageFrom: userId,
        roomId: roomId,
        deviceUniqueConnectionId: deviceConnectionId,
        messageType: MessageCategory.TYPE_LEAVE_ROOM
      };
      return this.getWebSocketInstance().then(function (connection) {
        self._loggerInstance.logEvent('Sending Leave Room Request to Signal Server');

        connection.send(JSON.stringify(leaveRoomMessage));
      });
    }
  }, {
    key: "JoinRoom",
    value: function JoinRoom(bridgeId, userId) {
      var logOutPreviousConnection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var self = this;
      var joinRoomRequest = {
        messageFrom: userId,
        messageType: MessageCategory.TYPE_JOIN_ROOM,
        roomId: bridgeId,
        deviceUniqueConnectionId: this._deviceConnectionId,
        logOutPreviousConnection: logOutPreviousConnection,
        messageId: Guid.NewGuid()
      };
      return this.getWebSocketInstance().then(function (connection) {
        self._loggerInstance.logEvent('Sending Join Room Request to Signal Server');

        connection.send(JSON.stringify(joinRoomRequest));
      });
    }
  }, {
    key: "OnSocketOpen",
    value: function OnSocketOpen() {
      console.log('WebSocket Client Connected');
    }
  }, {
    key: "OnMessage",
    value: function OnMessage(message) {
      var messageData = {};

      try {
        messageData = JSON.parse(message.data);

        if (messageData.messageType === MessageCategory.TYPE_WEBSOCKET_CONNECTION) {
          var connectionReply = messageData;

          if (connectionReply.responseStatus == ServerResponseStatus.Success) {
            this._isConnected = true;

            this._loggerInstance.logEvent("SignalServer connection succeeded");
          } else {
            this._loggerInstance.logException(new Error("SignalServer Connection Failure Response"));
          }
        }

        if (messageData.messageType === MessageCategory.TYPE_TEXT_MESSAGE) {
          this._eventEmitter.dispatch('ontextmessage', messageData);

          return;
        }

        if (messageData.messageType === MessageCategory.TYPE_LOGIN) {
          var loginResponse = messageData;

          if (loginResponse.responseStatus === ServerResponseStatus.Success) {
            this._deviceConnectionId = loginResponse.uniqueConnectionId ? loginResponse.uniqueConnectionId : "";

            this._eventEmitter.dispatch(WebSocketProxyEvents.OnLoginSuccess, this._deviceConnectionId);

            this._loggerInstance.logEvent("SignalServer Login succeeded");

            return;
          } else {
            this._loggerInstance.logException(new Error("Login Failure Response"));
          }

          return;
        }

        if (messageData.messageType === MessageCategory.TYPE_JOIN_ROOM_RESPONSE) {
          var joinRoomResponse = messageData;

          this._loggerInstance.logEvent("Join Room Action Completed with " + joinRoomResponse.joinRoomAction.toString(), joinRoomResponse);

          this._eventEmitter.dispatch(WebSocketProxyEvents.OnJoinRoomSuccess, joinRoomResponse);

          return;
        }

        if (messageData.messageType === MessageCategory.TYPE_OFFER_TO_BRIDGE) {
          var offerMessage = messageData;

          this._loggerInstance.logTrace("Offer from Peer");

          this._eventEmitter.dispatch(WebSocketProxyEvents.OnOfferFromPeer, offerMessage.offer);

          return;
        }

        if (messageData.messageType === MessageCategory.TYPE_SIGNAL_TO_BRIDGE) {
          var signalMessage = messageData;

          this._loggerInstance.logTrace("Signal from Peer");

          this._eventEmitter.dispatch(WebSocketProxyEvents.OnSignalFromPeer, signalMessage.signalData);

          return;
        }

        if (messageData.messageType === MessageCategory.TYPE_FORCED_LOGGED_OUT) {
          var forcedLoggedOut = messageData;

          this._loggerInstance.logTrace("Signal from Peer");

          this._eventEmitter.dispatch(WebSocketProxyEvents.OnForcedLoggedOut, forcedLoggedOut);

          return;
        }

        this._eventEmitter.dispatch("onmessage", message.data);
      } catch (e) {
        console.log("An error occurred while processing message: " + JSON.stringify(message));
        console.error("error: " + e);
        console.error("error Object: " + JSON.stringify(e));

        this._loggerInstance.logException(e);
      }
    }
  }, {
    key: "OnError",
    value: function OnError(error) {
      this._loggerInstance.logException(error);

      console.error(JSON.stringify(error));
    }
  }, {
    key: "OnClose",
    value: function OnClose(event) {
      this._isConnected = false;
      this._websocketClient = null;

      this._loggerInstance.logEvent("SignalServer connection closed");

      this._eventEmitter.dispatch(WebSocketProxyEvents.OnWebSocketDisconnected, {});

      console.log("OnClose event fired...");
      console.log(JSON.stringify(event));
    }
  }, {
    key: "SendTextMessage",
    value: function SendTextMessage(messageText, username, receiverUniquieDeviceId) {
      var _this2 = this;

      var self = this;
      var message = {
        messageFrom: this._currentUser_UserName,
        messageType: MessageCategory.TYPE_TEXT_MESSAGE,
        message: messageText,
        messageId: Guid.NewGuid(),
        messageTo: username,
        senderDeviceUniqueConnectionId: this._deviceConnectionId,
        receiverUniquieDeviceId: receiverUniquieDeviceId
      };

      self._eventEmitter.dispatch("ontextmessage", message);

      this.getWebSocketInstance().then(function (connection) {
        _this2._loggerInstance.logTrace("Sending Text Message to Peer");

        connection.send(JSON.stringify(message));
      });
    }
  }, {
    key: "SendOffer",
    value: function SendOffer(offerObject, bridgeId) {
      var _this3 = this;

      var message = {
        messageType: MessageCategory.TYPE_OFFER_TO_BRIDGE,
        bridgeId: bridgeId,
        messageFrom: this._currentUser_UserName,
        messageId: Guid.NewGuid(),
        offer: offerObject,
        senderDeviceUniqueConnectionId: this._deviceConnectionId
      };
      this.getWebSocketInstance().then(function (connection) {
        _this3._loggerInstance.logEvent("Sending Offer to Peer");

        connection.send(JSON.stringify(message));
      });
    }
  }, {
    key: "SendAnswer",
    value: function SendAnswer(answerObject, username, receiverUniquieDeviceId) {
      var _this4 = this;

      var message = {
        messageType: MessageCategory.TYPE_ANSWER,
        messageTo: username,
        messageFrom: this._currentUser_UserName,
        messageId: Guid.NewGuid(),
        answer: answerObject,
        senderDeviceUniqueConnectionId: this._deviceConnectionId,
        receiverDeviceUniqueConnectionId: receiverUniquieDeviceId
      };
      this.getWebSocketInstance().then(function (connection) {
        _this4._loggerInstance.logEvent("Sending Answer to Peer");

        connection.send(JSON.stringify(message));
      });
    }
  }, {
    key: "SendSignal",
    value: function SendSignal(signalObject, bridgeId) {
      var _this5 = this;

      var message = {
        messageType: MessageCategory.TYPE_SIGNAL_TO_BRIDGE,
        bridgeId: bridgeId,
        messageFrom: this._currentUser_UserName,
        messageId: Guid.NewGuid(),
        signalData: signalObject,
        senderDeviceUniqueConnectionId: this._deviceConnectionId
      };
      this.getWebSocketInstance().then(function (connection) {
        _this5._loggerInstance.logTrace("Sending Signal to Peer");

        connection.send(JSON.stringify(message));
      });
    }
  }, {
    key: "SubscribeWebSocketEvents",
    value: function SubscribeWebSocketEvents(eventName, eventHandler) {
      this._eventEmitter.subscribe(eventName, eventHandler);
    }
  }, {
    key: "UnsubscribeWebSocketEvents",
    value: function UnsubscribeWebSocketEvents(eventName, eventHandler) {
      this._eventEmitter.unsubscribe(eventName, eventHandler);
    }
  }], [{
    key: "GetInstance",
    value: function GetInstance() {
      return this._websocketsProxyInstance;
    }
  }]);

  return WebSocketProxy;
}();

_defineProperty(WebSocketProxy, "_websocketsProxyInstance", new WebSocketProxy());